/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCallLogParticipantFromJSON, StreemApiCallLogParticipantToJSON, } from './';
export function StreemApiCallLogRoomInvitationFromJSON(json) {
    return StreemApiCallLogRoomInvitationFromJSONTyped(json, false);
}
export function StreemApiCallLogRoomInvitationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fromUser': !exists(json, 'from_user') ? undefined : StreemApiCallLogParticipantFromJSON(json['from_user']),
        'toUser': !exists(json, 'to_user') ? undefined : StreemApiCallLogParticipantFromJSON(json['to_user']),
    };
}
export function StreemApiCallLogRoomInvitationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'from_user': StreemApiCallLogParticipantToJSON(value.fromUser),
        'to_user': StreemApiCallLogParticipantToJSON(value.toUser),
    };
}
//# sourceMappingURL=StreemApiCallLogRoomInvitation.js.map